/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { TotalsFromJSON, TotalsFromJSONTyped, TotalsToJSON, TotalsToJSONTyped, } from './Totals';
/**
 * Check if a given object implements the StatsSlotSlotIdGet200Response interface.
 */
export function instanceOfStatsSlotSlotIdGet200Response(value) {
    return true;
}
export function StatsSlotSlotIdGet200ResponseFromJSON(json) {
    return StatsSlotSlotIdGet200ResponseFromJSONTyped(json, false);
}
export function StatsSlotSlotIdGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'booked': json['booked'] == null ? undefined : (mapValues(json['booked'], TotalsFromJSON)),
        'unbooked': json['unbooked'] == null ? undefined : (mapValues(json['unbooked'], TotalsFromJSON)),
    };
}
export function StatsSlotSlotIdGet200ResponseToJSON(json) {
    return StatsSlotSlotIdGet200ResponseToJSONTyped(json, false);
}
export function StatsSlotSlotIdGet200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'booked': value['booked'] == null ? undefined : (mapValues(value['booked'], TotalsToJSON)),
        'unbooked': value['unbooked'] == null ? undefined : (mapValues(value['unbooked'], TotalsToJSON)),
    };
}
